import gql from 'graphql-tag'

export const GET_CATEGORY_LINK_BY_PATH = gql`
  query GetCategoryLinkByPath($categoryPath: String!, $isSoftCategory: Boolean!) {
    softCategoryByPath(categoryPath: $categoryPath, isSoftCategory: $isSoftCategory) {
      name
      pathSlug
      mostPopularProduct {
        searchResultProduct {
          displayName
          primaryImageId
        }
      }
    }
  }
`
